import { formatVariants } from '@sainsburys-tech/boltui-utils';

var formatProductData = function formatProductData(product) {
  var _product$included$fin;

  var attributes = product.data.attributes;
  var reviews = product.included.find(function (included) {
    return included.type === 'reviewstatistics';
  }).attributes;
  var images = product.included.find(function (included) {
    return included.type === 'media';
  }).attributes.images.slice(0, 4);
  var variants = product.included.find(function (included) {
    return included.type === 'variants';
  }).attributes.variants;
  var price = (_product$included$fin = product.included.find(function (included) {
    return included.type === 'prices';
  })) === null || _product$included$fin === void 0 ? void 0 : _product$included$fin.attributes;
  return {
    name: attributes.name,
    id: attributes.partNumber,
    price: price,
    images: images,
    reviews: reviews,
    description: attributes.description,
    variants: variants.length ? formatVariants(variants, attributes.partNumber) : []
  };
};

export default formatProductData;